<template>
  <div class="mb-5">
    <div class="d-flex justify-center" v-if="!ishavedata">
      <v-progress-circular color="blue" indeterminate />
    </div>
    <app-widget v-else
      title="Data - Variable Creation"
      headingicon="false"
      helpicon="true"
      imgname="table data-sheet.png"
      titleicon="mdi-grid"
      helpheading="Data - Variable Creation"
      no-padding
    >
      <div slot="help-content">
        Data - Variable Creation
      </div>

      <div slot="widget-content">
        <div>
          <v-simple-table fixed-header height="500">
            <thead>
              <tr>
                <th
                  v-for="(element, key) in itemlist[0]"
                  :key="element.variable"
                  class="text-center"
                  style="background: #f1f1f1"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span>
                        {{ key | tableheader }}
                        <span v-if="key === 'Sales_Value'"> ({{currency}}) </span>
                      </span>
                    </template>
                    <span>{{ key }}</span>
                  </v-tooltip>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item) in itemlist" :key="item">
                  <td v-for="(element, index) in item" :key="index" :class="['region', 'date'].includes(index) ? 'text-center' : 'text-right'">
                    <div :style="{width: index === 'date' ? '100px' : ''}">
                      <span v-if="fullNameIsExist(index)" class="titleText--text">
                      {{ fullName(index) === 'sales_value' ? currencyNumberFormat(element) : element}}
                      </span>
                      <span v-else-if="index === 'date'" class="titleText--text">{{ formattedDate(element) }}</span>
                    <span v-else class="titleText--text">{{ fullName(index) === 'sales_value' ? currencyNumberFormat(element) : numberFormat(element)}}</span>
                  </div>
                    
                  </td>
                </tr>
              </tbody>
          </v-simple-table>
        </div>
      </div>
    </app-widget>
  </div>
</template>
<script>
import apifactory from "../api";
import AppWidget from "../../../components/AppWidget.vue";
import moment from 'moment'

export default {
  components: {
    AppWidget,
  },
  props: {
    options: {
      type: [],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    ishavedata: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    itemlist: [],
    strnodatafount: "No Data Found",
    ishavedata: false,
    level: "",
    levelSubNation: "subnational",
    issubnation: false,
    columndesc: [],
    dataregionSelected: null,
    apidata: [],
  }),
  methods: {
    formattedDate (date) {
      return moment(date).format("DD.MM.YYYY")
    },
    fullNameIsExist (item) {
        let outresult=false;
        if(item == 'region'){outresult= true;}
        return outresult;
    },
    currencyNumberFormat (number) {
      const formatter = new Intl.NumberFormat('en-CA', {
        style: 'currency',
        maximumFractionDigits: 0,
        currency: this.currency || 'usd'
      })

      return formatter.format(number);
    },
    numberFormat (number) {
      const formatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 0,
      })

      return formatter.format(number)
    },
    refresh(vardataregionSelected) {
    //  alert(vardataregionSelected);
      this.dataregionSelected = vardataregionSelected;
      this.loadData();
    },
    loadData() {
      // alert(this.dataregionSelected);
      apifactory
        .call_getdata_fornewvarceation()
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            this.apidata = res.data.data;
            this.columndesc = res.data.column_description;
            this.level = res.data.project_level;
            //alert(this.level);
            if (this.level == "subnational") {
              this.isdatasublevel = true;
              this.itemlist = res.data.data.filter(
                (a) => a.region == this.dataregionSelected
              );
            } else {
              this.isdatasublevel = false;
              this.itemlist = res.data.data;
            }
            this.ishavedata = true;
          }
        })
        .catch(function (error) {
          alert('call_getdata_fornewvarceation' + error);
        });
    },
  },
  computed: {
    fullName() {
      return (theParam) => {
        let desc = [];
        desc = this.columndesc.filter((a) => a.column == theParam);
        return desc[0].description;
      };
    },
    isdatasublevel() {
      if (this.level === this.levelSubNation) {
        return true;
      } else {
        return false;
      }
    },
    currency () {
      return localStorage.getItem('currency')
    }
  },
  mounted() {
    this.refresh(this.title);
  },
};
</script>
<style>
table td {
  border-bottom: 1px solid #f1f1f1 !important
}

table thead,
table tr {
  border-bottom: 1px solid #f1f1f1
}
</style>